<template>
    <div class="footer-sticky" v-if="siteSettings?.announcement && $route.name == 'Home' && closeMarquee">
        <div class="commentry-sec">
            <div class="commentry-fixed-img">
                <img loading="lazy" src="@/assets/images/commentary.webp" alt="commentary">
            </div>
            <div class="moving-text">
                <marquee :style="{ color: siteSettings?.announcement?.color_code }" onmouseover="this.stop();" onmouseout="this.start();">{{ siteSettings?.announcement?.msg }}</marquee>
            </div>
            <button class="commentry-fixed-btn" @click="closeMarquee = false"><i class="fa fa-close"></i></button>
        </div>
        <div class="demo-login-footer" v-if="$auth.status && isDemo && !getGlobaLoader">
            <p>
                {{$t('this-is-demoid','This is Demo ID')}}
            </p>
        </div>
    </div>
    <section v-if="siteSettings && siteSettings?.business_type==2"  class="help-and-support-box">
        <div class="support-sec">
            <a ref="whatsappModal" v-if="$auth.status" href="javascript:void(0);" @click="getParentWhatsappNumber" data-bs-toggle="modal" data-bs-target="#whatsup-depositModal" target="_blank">
                <img loading="lazy" src="@/assets/images/wp_support.webp" alt="">
            </a>
            <a v-if="!$auth.status" ref="whatsappModal" :href="'https://wa.me/' + siteSettings.social_link?.whatsappno1"  target="_blank">
                <img loading="lazy" src="@/assets/images/wp_support.webp" alt="">
            </a>
        </div>
    </section>
    
    <ChatComponent></ChatComponent>
    <!--Whatsup Deposit Modal -->
    <div class="modal fade whatsup-modal-wrapper" id="whatsup-depositModal" tabindex="-1" aria-labelledby="whatsupModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header headerTheme">
                    <h5 class="modal-title" id="exampleModalLabel">{{$t('customer-support','Customer Support')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="modal-body whatsup-modal-information">
                    <div class="whatsaap-support-btn-list" v-if="whatsappNumbers && whatsappNumbers.length > 0">
                        <div class="support-call-now" v-for="(data, index) in whatsappNumbers" :key="index">
                            <a :href="'https://wa.me/' + data.whatsapp_number" target="_blank">
                                <div class="support-whatsapp-icon"><img src="@/assets/images/whatsapp.svg" alt="whatsapp"></div>
                                <span>{{ data.category_name }}</span>
                            </a>      
                        </div>
                    </div>
                    <div class="whatsaap-support-btn-list" v-else-if="siteSettings && (siteSettings.social_link?.whatsappno1 || siteSettings.social_link?.whatsappno2)">
                        <div class="support-call-now" v-for="number in [siteSettings.social_link?.whatsappno1, siteSettings.social_link?.whatsappno2]">
                            <a v-if="number" 
                                :key="number" 
                                :href="'https://wa.me/' + number" 
                                target="_blank" 
                                class="btn thm-btn call-now">
                                <div class="support-whatsapp-icon"><img loading="lazy" src="@/assets/images/whatsapp.svg" alt="whatsapp"></div>
                                <span>{{ number }}</span>
                            </a>
                        </div>
                    </div>
                    <div v-else>
                        <p>{{$t('no-whatsapp-avail','No WhatsApp numbers available.')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- mini game -->
    <div class="gameon-btn" @click="getMiniGame" v-if="$route.name == 'Home'">
		<a href="javascript:void(0)"><img src="@/assets/images/casino-chip.png" alt="promot" /></a>
	</div>
    <div class="game_lobby_iframe" v-if="isShowing" ref="game_lobby_iframe">
        <span class="lobby-iframe-close-icon" @click="isShowing = false"><img loading="lazy" src="@/assets/images/arow-down.svg"
                alt="cross-icon" /></span>
        <iframe :src="iFrameUrl"></iframe>
    </div>
</template>

<script>

import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';

export default {
    name: 'Footer',
    components:{
        ChatComponent: defineAsyncComponent(() =>
            import('@/modules/chat/views/ChatComponent.vue')
        ),
    },
    computed: {
        ...mapGetters(['gamesData']),
        siteSettings() {
            return this.$store.getters.siteSettings;
        },
        domainName() {
            return this.$store.getters.domainName;
        },
        isDemo(){
            return localStorage.getItem('login_type') == 'demo'
        },
        getGlobaLoader() {
			return this.$store.getters.globalLoader;
		},
    },
    data() {
        return {
            whatsappNumbers:[],
            isShowing: false,
            iFrameUrl: null,
            miniGameUrl: null,
            closeMarquee: true,
        }
    },
    methods: {
        async getParentWhatsappNumber() {
            if (this.$auth?.status) {
                this.loading = true;
                try {
                    const cpiExists = this.$auth?.user?.cpi;
                    const supportNumbers = this.siteSettings.support_numbers || [];
                    if (!cpiExists) {
                        return;
                    }
                    const now = new Date();
                    const totalMinutes = now.getHours() * 60 + now.getMinutes();

                    this.whatsappNumbers = supportNumbers
                        .filter(entry => entry.id === cpiExists)
                        .flatMap(entry => entry.categories.map(category => {
                            const whatsappNumbers = category.value.split(',');
                            const selectedNumberIndex = totalMinutes % whatsappNumbers.length;
                            return {
                                category_name: category.name,
                                whatsapp_number: whatsappNumbers[selectedNumberIndex]
                            };
                        }));
                    this.loading = false;
                } catch (error) {
                    this.loading = false;
                    console.log(error);
                    this.$errorToast(error[0]);
                }
            } else {
            }
        },
        async getMiniGame() {
            let sectionName = "home-casino" // please put here the section name for mini game, its random right now
            if (!this.$auth?.status) {
                this.isShowing = false;
                return this.$errorToast("Please Login For Mini Games");
            }
            
            const miniGameData = this.gamesData.sections.find(
                (gm) => gm.slug === sectionName
            )?.games?.[0];
            if (!miniGameData) {
                this.$errorToast("Mini Game Data Not Found.");
                this.closeMiniGame();
                return;
            }
            this.$apiCall('post', 'DREAM_CASINO', {}, 'user', { game_code: miniGameData.game_code, sm_id: miniGameData.sm_id }).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        this.isShowing = true;
                        this.iFrameUrl = response?.data?.data?.url;
                        if (this.miniGameUrl == null || this.miniGameUrl == undefined || this.miniGameUrl == '') {
                            this.$errorToast('URL not found.')
                            this.closeMiniGame();
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                this.closeMiniGame();
                if (error) {
                    this.$errorToast(error[0] || 'An error occurred.');
                }
            });
        },
        closeMiniGame() {
            this.isShowing = false;
        },
    },
}
</script>